import { nFormatter } from "utils/parseNumber";

import { ReactComponent as ImageIcon } from "components/icons/Eye_Show.svg";
import { ReactComponent as VideoIcon } from "components/icons/playIcon.svg";
import { ReactComponent as SearchIcon } from "components/icons/search.svg";

import "../buttons.scss";

export enum ViewsButtonType {
  VIDEO = 1,
  IMAGE = 2,
  SEARCH = 3
}

interface IViewsButtonProps {
  count: number;
  onClick?: () => void;
  type?: ViewsButtonType;
}

export const ViewsButton: React.FC<IViewsButtonProps> = ({ count, onClick, type }) => {

  const renderIconUrl = () => {
    const { IMAGE, SEARCH } = ViewsButtonType;

    if (type === IMAGE) {
      return <ImageIcon />;
    }

    if (type === SEARCH) {
      return <SearchIcon />;
    }

    return <VideoIcon />;
  };

  const handleClick = () => {
    onClick && onClick();
  };

  return (
    <button
      className="rg-button views icon"
      onClick={handleClick}
    >
      {renderIconUrl()}
      <div className="label">{nFormatter(count)}</div>
    </button>
  );
};
